import React, { useEffect, useMemo, useState } from "react";
import styles from "./PreviewFormula.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { useDispatch, useSelector } from "react-redux";
import { clearScoreValue, clearSelectedOptionsForFormula, setFinalScore, setScoreValue } from "@redux/slices/scoringSlice";
import { useFetcher } from "react-router-dom";

function roundTo(num, precision) {
  const factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
}


const PreviewFormula = (props) => {
  const [showIcon, setShowIcon] = useState(true);
  const { selectedOptionsForFormula, scoreValue } = useSelector((state) => state.score);
  const dispatch = useDispatch();
  const value = useMemo(() => {
    let selectedIds = Object.keys(selectedOptionsForFormula);
    const fields = props.weights.filter((weight) =>
      selectedIds.includes(weight.fieldId) || weight?.scoreType === "byFormula"
    );
    let extractFormulaId = (weightId, value) => {
      props?.weights?.forEach((e) => {
        if (e?._id == weightId) {
          dispatch(setScoreValue({
            [props._id]: value
          }))
        }
      })

    }

    const availableIds = fields.map((field) => field.fieldId);
    const extractWeightsFromId = (id) => {
    }
    const maxWeight = fields?.reduce((acc, curr) => {
      if (curr?.type === "formula") {
        let foundValue = false;
        for (const e of scoreValue || []) {
          if (foundValue) break;
          for (const key in e) {
            if (key === curr?.fieldId && e[key]) {
              acc += e[key];
              foundValue = true;
              break;
            }
          }
        }
      } else {
        acc += curr?.maxWeight || 0;
      }
      return acc;
    }, 0) || 0;


    let finalValue = 0;

    const timeToSeconds = (time) => {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    };

    fields.forEach((field, index) => {
      const selectedValue = selectedOptionsForFormula[field.fieldId];

      if (field.scoreType === "byOptions") {
        let assignedValue;
        if (!selectedValue) {
          assignedValue = field.options?.find(
            (option) => option.option === "Unanswered"
          );
        } else {
          if (Array.isArray(selectedValue)) {
            selectedValue?.forEach((e) => {

              assignedValue = field.options?.find(
                (option) => option.option === e
              );
            });
          } else {
            assignedValue = field.options?.find(
              (option) => option.option === selectedValue
            );
          }
        }


        if (assignedValue) {
          if (props.formulaType === "Subtract" && index) {
            finalValue -= assignedValue.score;
          }
          else if (props?.formulaType === "Advance") {
            if (props?.advanceFormulaEval) {
              finalValue += eval(`${assignedValue.score / props?.maxFormulaScore}${props.advanceFormulaEval}`)
              finalValue = Math.round(finalValue * 100) / 100;
            }

          }

          else {
            finalValue += assignedValue.score;
          }
        }
      }
      else if (field.scoreType === "byRange") {
        if (selectedValue !== undefined) {
          let assignedValue = 0;

          const isTimeRange =
            typeof selectedValue === "string" && selectedValue.includes(":");

          const rangeMatch = field.range.between?.find((range) => {
            const [low, high] = range.option
              .split("-")
              .map((val) => (isTimeRange ? timeToSeconds(val) : Number(val)));
            const valueToCompare = isTimeRange
              ? timeToSeconds(selectedValue)
              : Number(selectedValue);
            return valueToCompare >= low && valueToCompare < high;
          });

          if (rangeMatch) {
            assignedValue = rangeMatch.score;
          } else {
            const lowerBound = isTimeRange
              ? timeToSeconds(field.range.lowerBound.option)
              : field.range.lowerBound.option;
            const upperBound = isTimeRange
              ? timeToSeconds(field.range.upperBound.option)
              : field.range.upperBound.option;
            const valueToCompare = isTimeRange
              ? timeToSeconds(selectedValue)
              : Number(selectedValue);

            if (valueToCompare < lowerBound) {
              assignedValue = field.range.lowerBound.score;
            } else if (valueToCompare >= upperBound) {
              assignedValue = field.range.upperBound.score;
            }
          }

          if (props.formulaType === "Subtract" && index)
            finalValue -= assignedValue;
          else finalValue += assignedValue;
        }
      }
      else if (field?.scoreType === "byFormula") {
        for (const e of scoreValue) {
          const entry = Object.entries(e || {}).flat(1);
          const [key, value] = entry;
          if (field?.fieldId == key) {
            if (props.formulaType === "Subtract" && index) {
              finalValue -= value;
            }
            else if (props?.formulaType === "Advance") {
              if (props.advanceFormulaEval) {
                finalValue += eval(`${value / props?.maxFormulaScore}${props.advanceFormulaEval}`)
                finalValue = Math.round(finalValue * 100) / 100;
              }

            }
            else {
              finalValue += value;
            }

            break;
          }
        }
      }else{
        finalValue += selectedValue;
      }
    }
    );

    if (finalValue && props.formulaType === "Percentage") {
      finalValue = roundTo((finalValue / maxWeight) * 100, 2);
    }

    if (finalValue && props.formulaType === "Average") {
      finalValue = roundTo(finalValue / availableIds.length, 2);
    }

    // let isFormula = props?.weights?.filter((e) => e?.scoreType == "byFormula")
    // if (isFormula?.length) {

    // } else {
    //   dispatch(setFinalScore(finalValue))
    // }

    props?.weights?.forEach((e) => {
      extractFormulaId(e?._id, finalValue)
      // console.log('extractFormulaId(e?._id)', extractFormulaId(e?._id))
      // dispatch(setScoreValue({
      //   [extractFormulaId(e?._id)]: finalValue
      // }))
    })



    return finalValue;
  }, [props.weights, selectedOptionsForFormula, props.formulaType]);

  useEffect(() => {
    return () => {
      dispatch(clearSelectedOptionsForFormula());
      dispatch(clearScoreValue())
    };
  }, [dispatch]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>{props?.data?.value || props?.name || props?.label}</span>
          {props?.instructions || props?.data?.media?.length ? (
            <div className={styles?.icon}>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.inputText}>
          <input
            disabled
            value={value}
            className={styles.textField}
            placeholder="text"
          />
        </div>
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
          {/* <div className={styles.imageStyle}> Photo</div> */}
        </div>
      )}
    </div>
  );
};

export default PreviewFormula;
